import React from 'react';
import './MainMenu.css';

const MainMenu = ({ onStartGame, onStartBombGame, onStartNormalSudoku }) => {
  return (
    <div className="main-menu">
      <div className="main-menu-content">
        <h1 className="main-menu-title">数独補助輪</h1>
        <div className="main-menu-subtitle">理論で理解する数独</div>
        
        <div className="menu-description">
          <p>数独マスターは、数独の「一意解」に着目した3つのゲームモードを提供します。</p>
          <p>通常モードでは二人で交互に数字を消し、一意解（解が1つだけ）を維持できなくなったプレイヤーの負けとなります。</p>
          <p>危機一髪モードでは一人で遊べる「正解を探す」ゲームです。おまけの数独モードも楽しめます。</p>
        </div>
        
        <div className="game-mode-buttons">
          <button className="start-normal-sudoku-button" onClick={onStartNormalSudoku}>
            数独補助輪
          </button>
          <button className="start-game-button" onClick={onStartGame}>
            ミニゲーム：数独Jenga
          </button>
          <button className="start-bomb-button" onClick={onStartBombGame}>
            ミニゲーム：数独危機一髪
          </button>
        </div>
        
        <div className="menu-footer">
          <p>数独補助輪：1人プレイ - 通常の数独パズルを解こう！</p>
          <p>数独Jenga：2人プレイ推奨 - 交代でプレイしてください</p>
          <p>数独危機一髪：1人プレイ - 消せるマスを探そう！</p>
        </div>
      </div>
    </div>
  );
};

export default MainMenu;